// extracted by mini-css-extract-plugin
export default {"wrapper":"wZgqICHqGEpKPFRhEdj5","list":"s14gAYhVsiwbdn33g4W7","listItem":"P3JKxwX2B8CRdy2MqkrI"};